import { devError } from './devLog';
import { axiosRequest } from './axiosHttp';

export const axiosPut = (urlParameters, formData) =>
  axiosRequest('put', urlParameters, formData).catch((err) => {
    devError('axiosPut failed:', err);
  });
